import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    color: theme.palette.neutralDark,
    padding: `${pxToRem(22)} 0 ${pxToRem(12)} ${pxToRem(16)}`,
    margin: `0 ${pxToRem(24)} 0 ${pxToRem(24)}`,
  },
  header: {
    fontSize: pxToRem(18),
    borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralTertiaryAlt}`,
  },
  subHeader: {
    fontSize: pxToRem(14),
  },
});
